import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';

import store from './state/store';
import './index.css'; // TODO: This needs types or sth
import App from './App';
import { asyncPersister } from './offline/persister';
import { queryClient } from './queryClient';

// Note: The below is for Tanstack Query Dev Tools to work and it doesn't emit any javascript, so it doesn't need any 'isDevelopment' guards:
declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__:
    import('@tanstack/query-core')
    .QueryClient
  }
}

if (import.meta.env.DEV) {
  window.__TANSTACK_QUERY_CLIENT__ = queryClient
}

console.info(`Eclipse frontend build ${__BUILD_ID__}`);
(window as unknown as { __ECLIPSE_BUILD__: string }).__ECLIPSE_BUILD__ = __BUILD_ID__;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <Provider store={store}>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{
          persister: asyncPersister,
          maxAge: 1000 * 60 * 60 * 24 * 7,
        }}
      >
        <App />
      </PersistQueryClientProvider>
    </Provider>
  </StrictMode>
);